import React from "react";
import styles from "./ProductDetails.module.css";
import CTAButton from "../../../components/CTAButton";
import ObservedSection from "../../../components/ObservedSection";

const ProductDetails = ({ onCtaEnter, onCtaExit }) => {

    function getImageNames() {
        const gifs = [2, 5, 6, 11, 15, 17, 18, 20, 22]
        const pngs = []
        const names = []
        for (var i = 0; i <= 30; i++) {
            names.push(`${i}.${gifs.includes(i) ? "gif" : pngs.includes(i) ? "png" : "jpg"}`)
        }
        return names
    }
    return (
        <div className={styles.container}>
            {getImageNames().map((image, i) => {
                return (
                    <>
                        {/* {i == 11 && <div className={styles.cta_wrapper}>
                            <ObservedSection
                                onEnter={() => onCtaEnter && onCtaEnter()}
                                onLeave={() => onCtaExit && onCtaExit()}
                            >
                                <CTAButton
                                    className={styles.cta}
                                    titleClass={styles.cta_title}
                                    subtitleClass={styles.cta_sub} />
                            </ObservedSection>
                        </div>} */}
                        <img className={styles.image} src={`${process.env.PUBLIC_URL}/assets/images/${image}`} key={i} />
                    </>
                )
            })}
            <ObservedSection
                onEnter={() => onCtaEnter && onCtaEnter()}
                onLeave={() => onCtaExit && onCtaExit()}
            >
                <CTAButton
                    className={styles.cta}
                    titleClass={styles.cta_title}
                    subtitleClass={styles.cta_sub}
                />
            </ObservedSection>

        </div>

    )
}

export default ProductDetails